export default __webpack_public_path__ + "static/Poppins-Medium-289636bed6a32f38a51f38a87275fe32.woff";